<template>
  <div class="c-t-default">
    <site-header></site-header>
    <transition name="o-transition--fade" mode="out-in">
      <div v-if="!isLoading && !error && post != null" key="content">
        <hero :hero="post.acf.hero"></hero>
        <sections-wrapper :sections="post.acf.sections"></sections-wrapper>
      </div>
      <div v-else-if="!isLoading && error" key="error">
        <error-state></error-state>
      </div>
      <div v-else key="loading">
        <loader class="c-m-loader--x-large"></loader>
      </div>
    </transition>
    <site-footer></site-footer>
  </div>
</template>

<style>
</style>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_CONTENT_BY_SLUG,
  GET_CONTENT,
  IS_LOADING,
  GET_ERROR
} from "../store/store-models/content-model";

import SiteHeader from "./components/organisms/OrganismSiteHeader.vue";
import Hero from "./components/organisms/OrganismHeroHomeCompany.vue";
import SectionsWrapper from "./SectionsWrapper.vue";
import SiteFooter from "./components/organisms/OrganismSiteFooter.vue";
import Loader from "./components/molecules/MoleculeLoader.vue";
import ErrorState from "./components/molecules/MoleculeErrorState.vue";

export default {
  async asyncData({ store, route }) {
    return store.dispatch(FETCH_CONTENT_BY_SLUG, "for-hantverkare");
  },
  components: {
    SiteHeader,
    Hero,
    SectionsWrapper,
    SiteFooter,
    Loader,
    ErrorState
  },
  data() {
    return {
      slug: "for-hantverkare"
    };
  },
  computed: {
    ...mapGetters({
      post: GET_CONTENT,
      isLoading: IS_LOADING,
      error: GET_ERROR
    })
  },
  metaData() {
    return {
      title: "För hantverkare - Hjälp att hitta byggprojekt",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "BraByggare är en tjänst som gör det enkelt och effektivt att hitta byggprojekt som passar just dig. Mindre tid för resor och administration och mer tid för att jobba och fakturera. Du ökar helt enkelt dina intäkter, låter ganska bra eller hur?    När du blir medlem så får du ange en sökprofil med byggkategorier och kommuner för de typer av uppdrag du är mest intresserad. Du får även en profilsida där du kan lägga in information om företaget, certifieringar, bilder på referensuppdrag, länk till din hemsida m.m.   Nu får du mail med förfrågningar som matchar din sökprofil. Varje förfrågan innehåller en bra beskrivning av jobbet, uppskattad budget och starttidpunkt för att du lättare ska kunna sortera bort det som inte är intressant. Det spar mycket tid och onödiga platsbesök."
        }
      ],
      link: [
        {
          rel: "canonical",
          href: `${process.env.SITE_BASE_URL}${this.$route.path}`
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/views/HomeCompany.vue